export { CloseIcon } from './close';
export { ChangePageIcon } from './content';
export { ErrorIcon } from './error';
export { NotificationIcon } from './notification';
export { SearchIcon } from './search';
export { MoreIcon, ThemeIcon } from './sidebar';
export { BeIcon, BallIcon, GmailIcon, OutlookIcon, FacebookIcon, LinkedinIcon } from './social';
export { TasksIcon } from './tasks';
export { EditIcon, EditUndoIcon, EditPageContentIcon } from './edit';
export { DeleteIcon } from './delete';
export { PlusIconIcon } from './plus';
export { EyeOpenIcon, EyeCloseIcon } from './eye';
